module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/ex-seasonal-39169fcec1d580ccd1efbbed7af19ee1.png";